let locations = null;
export default HTTPClient => ({
  getAll: async () => {
    if (!locations) {
      locations = await HTTPClient.get('locations-v2.json');
    }
    return locations;
  },
});
